import React, {useState, useEffect, Fragment } from 'react';
import { 
         Button,
         Checkbox,
         Grid,     
         CircularProgress,
         LinearProgress,
         Paper,
         TextField,
         withWidth
        } from '@material-ui/core';
import { 
            CheckBox as CheckBoxIcon,
            CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
            Clear as ClearIcon,
            Send as SendIcon,
        } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { useAuth } from "../Auth";
import Swal from 'sweetalert2';
import { Switch as SwitchAntd, Tooltip as TooltipAntd } from 'antd';

function CambioPlanes({width:widthWin}){
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const { authTokens, setRuta } = useAuth(); 
    const [ dataZona, setDataZona ] = useState([]);
    const [ zonaSelected, setZonaSelected ] = useState('');
    const [ isProcessing, setProcessing ] = useState(false);
    const [ getServicio, setServicio ] = useState(false);
    const [ getArrClientes, setArrClientes ] = useState([]);
    const [ getClientes, setClientes ] = useState([]);
    const [ getBackupClientes, setBackupClientes ] = useState([]);
    const [ zonaCliente, setZonaCliente ] = useState('');
    const [ getNombres, setNombres ] = useState(true);
    const [ getPlanNuevo, setPlanNuevo ] = useState('');
    const [ getPlanNuevoObject, setPlanNuevoObject ] = useState({});
    const [ getPlanesN, setPlanesN ] = useState([]);
    const [ getPlanes, setPlanes ] = useState([]);
    const [ isContinuo, setContinuo ] = useState(false);
    const [ getNumber, setNumber ] = useState(0);
    const [ isSelectZone, setSelectZone ] = useState(false);
    const [ getZoneObject, setZoneObject ] = useState({});

    
    useEffect(
        ()=>{
            async function ReqInfo() {
                setRuta('/Clientes/CambioPlanes');
                const dataZonas = await fetch(`/api/Zonas/byEmpresa/${authTokens.Empresa}`);
                const resultZonas = await dataZonas.json();
                const dataClientes = await fetch(`/api/ClientesbyEmpresa/${authTokens.Empresa}`);
                const resultClientes = await dataClientes.json();
                const dataPlanes = await fetch(`/api/PlanesbyEmpresa/${authTokens.Empresa}`);
                const resuPlanes = await dataPlanes.json();
                setPlanes(resuPlanes);
                setBackupClientes(resultClientes.filter(el=>el.Status === 'Activo'));
                if(authTokens.Type === 'ADMINISTRADOR'){
                    setDataZona(resultZonas);
                }else{              
                    const ZonasArr = authTokens.Zonas.map(valZon=> valZon.Zona);
                    const arrFilZona = resultZonas.filter(value=> ZonasArr.includes(value.Zona.toString()))
                    setDataZona(arrFilZona);
                } 
            };
        
            ReqInfo();
        },[] // eslint-disable-line react-hooks/exhaustive-deps
    );

    useEffect(()=>{
        if(isContinuo){
            setContinuo(false);
            handleChangePlan();
        }
    },[isContinuo]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleClearZona = ()=>{
        setZonaSelected([]);
        setPlanesN([]);
        setSelectZone(false);
        setZoneObject({});
    };

    const handleSelectZona = (valZ)=>{
        setSelectZone(true);
        setZonaSelected(valZ);
        const filZona = dataZona.find(el=> el.Zona === valZ);
        setZoneObject(filZona);
        if(filZona.planLocal){
            setPlanesN(filZona.Planes);
        }else{
            setPlanesN(getPlanes);
        }
        const arrNuevo = [];
        for(const x in getBackupClientes){
            const elCliente = getBackupClientes[x];
            if(elCliente.Servicios.length > 0){
                for(const y in elCliente.Servicios){
                    const elServicio = {...elCliente.Servicios[y]};
                    elServicio.idCliente = elCliente._id;
                    elServicio.Nombres = elCliente.Nombres;
                    elServicio.CI = elCliente.CI;
                    elServicio.ZonaService === valZ && arrNuevo.push(elServicio);
                }
            }
        }
        setArrClientes(arrNuevo);
    };

    const handleClear = ()=>{
        setZonaSelected([]);
        setServicio(true);
        setClientes([]);
        setZonaCliente('');
        setNombres(true);
        setPlanesN([]);
        setPlanes([]);
        setPlanNuevoObject({});
        setPlanNuevo('');
        setSelectZone(false);
        setZoneObject({});
        setArrClientes([]);
        setProcessing(false);
    };

    const handleTipoServicio = (checked)=>{ setServicio(checked); };

    const handleSelectZona2 = (e, value, reason)=>{
        if(reason ===  'clear'){
            setZonaCliente('');
            setClientes([]);
            setPlanesN('');
            setSelectZone(false);
            setZoneObject({});
        }else{
            setSelectZone(true);
            setZonaCliente(value);
            const arrNuevo = [];
            for(const x in getBackupClientes){
                const elCliente = getBackupClientes[x];
                for(const y in elCliente.Servicios){
                    const elServicio = {...elCliente.Servicios[y]};
                    elServicio.idCliente = elCliente._id;
                    elServicio.Nombres = elCliente.Nombres;
                    elServicio.CI = elCliente.CI;
                    elServicio.ZonaService === value && arrNuevo.push(elServicio);
                }
            }
            setClientes(arrNuevo);
            const filZona = dataZona.find(el=> el.Zona === value);
            setZoneObject(filZona);
            if(filZona.planLocal){
                setPlanesN(filZona.Planes);
            }else{
                setPlanesN(getPlanes);
            }
        }
    };

    const handleSelectClient = (e, value, reason)=>{
        if(reason ===  'clear'){
            setArrClientes([]);
        }else{
            setArrClientes(value);
        }
    };

    const handleSwitchNombres = (checked)=>{ setNombres(checked); };

    const handleSelectPlanNuevo = (e, value, reason)=>{
        if(reason ===  'clear'){
            setPlanNuevo('');
            setPlanNuevoObject({});
        }else{
            setPlanNuevo(value);
            const elNuevo = getPlanesN.find(el=>el.PlanComercial === value);
            setPlanNuevoObject(elNuevo);
        }
    };

    const handleChangePlan = ()=>{
        if(getNumber < getArrClientes.length){
            const laZona = {...getZoneObject};
            laZona.Planes = getPlanesN;
            const elServicio = {...getArrClientes[getNumber]};
            elServicio.PlanComercialBack = elServicio.PlanComercial;
            elServicio.PlanNuevo = getPlanNuevoObject;
            elServicio.InfoZona = laZona;
            elServicio.PlanComercial = getPlanNuevoObject.PlanComercial;
            fetch('/api/clientes/servicios/cambioPlanes',{
                method:'POST',
                body: JSON.stringify(elServicio),
                headers:{'Content-Type': 'application/json'}
            }) 
            .then(response=> response.json())
            .then((result) =>{
                if(result.message){
                    setNumber(oldMac=> oldMac + 1 );
                    setContinuo(true);
                }else{
                    setProcessing(false);
                }
            });
        }else{
            setNumber(0);
            setProcessing(false);
            Swal.fire({
                title: 'COMPLETADO',
                icon:'success',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596'
            })
        }
    };

    const handleValidatePlan = ()=>{
        setProcessing(true);
        if(getPlanNuevo === ''){
            Swal.fire({
                title:'SELECCIONE EL PLAN NUEVO',
                icon:'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                width:500
            });
            setProcessing(false);
        }else{
            if(getServicio){
                handleChangePlan();
            }else{
                if(getArrClientes.length === 0){
                    Swal.fire({
                        title:'SELECCIONE POR LO MENOS 1 CLIENTE',
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:500
                    });
                    setProcessing(false);
                }else{
                    handleChangePlan();
                }
            }
        }

    };


    return(
        <Fragment>
            <Grid container spacing={1} style={{padding:10, width:'100%', height:'90vh'}} justifyContent='center' alignItems='flex-start'>
                <Grid item xl={5} lg={5} md={8} sm={12} xs={12} >
                    <Paper elevation={3} style={{padding:15, width:'100%', minHeight:300, overflow:'auto', maxHeight:'80vh'}}>
                        <Grid container spacing={2} justifyContent='center'>
                            <Grid item xs={12} style={{height:5}}>
                                {isProcessing &&  <LinearProgress color='secondary' /> }
                            </Grid>
                            <Grid item xs={12} style={{alignSelf:'center'}}>
                                <Grid container spacing={2} justifyContent='center'>
                                    <Grid item>
                                        <b>
                                            SELECCIONE COMO DESEA TRABAJAR:
                                        </b>
                                    </Grid>
                                    <Grid item>
                                        <TooltipAntd title="COMO DESEA TRABAJAR? " color='blue' >
                                            <SwitchAntd size='large' checkedChildren="ZONAS" unCheckedChildren="CLIENTES" checked={getServicio} onChange={handleTipoServicio} />
                                        </TooltipAntd>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {
                                getServicio ?
                                <Fragment>
                                    <Grid item xs={12}>
                                        <Autocomplete
                                            id="Zona"
                                            options={dataZona.map(value=>value.Zona)}
                                            value={zonaSelected || ''}                              
                                            renderInput={(params) => <TextField {...params} label="Zonas" variant="outlined" size='small' fullWidth color='primary'/>}
                                            onChange={(e,value, reason)=>{
                                                if(reason ===  'clear'){
                                                    handleClearZona()
                                                }else{
                                                    handleSelectZona(value);
                                                }
                                            }} 
                                        />
                                    </Grid>   
                                </Fragment>:
                                <Fragment>
                                    <Grid item xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={8}>
                                                <Autocomplete
                                                    id="Zona"
                                                    options={dataZona.map(value=>value.Zona)}
                                                    value={zonaCliente || ''}                              
                                                    renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                                    onChange={handleSelectZona2} 
                                                />
                                            </Grid>
                                            <Grid item xs={4} style={{display:'grid', placeContent:'center'}}>
                                                <TooltipAntd title="NOMBRES O CEDULA" color='blue' >
                                                    <SwitchAntd checkedChildren="NOMBRES" unCheckedChildren="CEDULA" checked={getNombres} onChange={handleSwitchNombres} />
                                                </TooltipAntd>
                                            </Grid> 
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Autocomplete
                                            id="Cliente"
                                            multiple
                                            getOptionLabel={(option)=> getNombres ? option.Nombres : option.CI}
                                            options={getClientes}
                                            value={getArrClientes || ''}                              
                                            renderInput={(params) => <TextField {...params} label={getNombres ? "Nombres" : 'CI'} variant="outlined" size='small' fullWidth color='primary'/>}
                                            onChange={handleSelectClient} 
                                            renderOption={(option, { selected }) => (
                                                <React.Fragment style={{fontSize:10}} key={option._id}>
                                                    <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={selected}
                                                    />
                                                {getNombres ? option.Nombres : option.CI}
                                                </React.Fragment>
                                            )}
                                        />
                                    </Grid> 
                                </Fragment>
                            }
                            {
                                isSelectZone ? 
                                <Grid item xs={12}>
                                    <Autocomplete
                                        id="PlanNuevo"
                                        options={getPlanesN.map(el=> el.PlanComercial)}
                                        disabled={!isSelectZone}
                                        value={getPlanNuevo || ''}                              
                                        renderInput={(params) => <TextField {...params} label="Plan Nuevo" variant="outlined" size='small' fullWidth color='primary'/>}
                                        onChange={handleSelectPlanNuevo} 
                                    />
                                </Grid> : null
                            }
                            <Grid item xs={6} md={4}>
                                    <Button 
                                        fullWidth 
                                        size='medium' 
                                        variant="contained" 
                                        color="secondary"
                                        onClick={ handleClear } 
                                        endIcon={ <ClearIcon/> } >
                                        RESETEAR
                                    </Button>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <TooltipAntd color='lime' title='ENVIAR'>
                                    <span>
                                    <Button 
                                        fullWidth 
                                        size='medium' 
                                        variant="contained" 
                                        color='primary' 
                                        endIcon={ isProcessing ? <CircularProgress size={20}  /> :  <SendIcon /> } 
                                        onClick={ handleValidatePlan } >
                                        ENVIAR
                                    </Button>
                                    </span>
                                </TooltipAntd>
                            </Grid>
                            
                        </Grid>   
                    </Paper>
                </Grid>
                
            </Grid>
            
        </Fragment>
    );
};


export default withWidth()(CambioPlanes);